import { useCallback } from "react";
import { useSelector } from "react-redux";

import { Contact } from "../../internal-contacts/_types/internalContacts.types";
import { getContactTitle } from "../../internal-contacts/_utils/internalContacts.utils";
import { resolveReceiverUserUid } from "../../internal-contacts/_utils/callRoom.utils";
import { useInternalTwilioCall } from "../context/InternalTwilioCallContext";

/**
 * Mobile no longer mounts LiveKit. Every person-to-person call from web must use Twilio Client
 * so the phone receives a CallInvite in both foreground (in-app UI) and VoIP/CallKit.
 */
export const useStartInternalTwilioPersonCall = () => {
  const { company } = useSelector((state: any) => state.userState);
  const { makeCall } = useInternalTwilioCall();

  return useCallback(
    async (contact: Contact, source: string) => {
      const receiverUid = resolveReceiverUserUid(contact);
      const targetCompanyId = contact.companyId ?? company?.id;
      if (!receiverUid || !targetCompanyId) return false;
      await makeCall(receiverUid, targetCompanyId, getContactTitle(contact));
      return true;
    },
    [company?.id, makeCall],
  );
};
